import * as React from "react";
const SvgVectorRed = (props) => /* @__PURE__ */ React.createElement("svg", { width: 168, height: 95, viewBox: "0 0 168 95", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M168 95H-83V0H97.9932L168 95Z", fill: "#C7534B" }));
export default SvgVectorRed;
